<template>
    <v-container v-if="isAdminOrCompanyCoordinator" fluid class="px-10 export-container" id="export">
        <h1 class="mb-5">Exports </h1>
        <div class="export-container">
            <v-card v-if="config.hasPagonisFileExportInfo" class="download-card">
                <v-card-title>
                    <v-icon color="green" class="mr-2">mdi-clipboard-arrow-down-outline</v-icon>Αρχείο από Παγώνη
                </v-card-title>
                <v-card-subtitle>
                    Το αρχείο Excel του Παγώνη αυτούσιο.
                </v-card-subtitle>
                <v-file-input
                    v-model="pagonisInfoFile"
                    accept="text/xlsx, .xlsx"
                    placeholder="Επιλογή Excel Αναθέσεων"
                    label="Επιλογή Excel Αναθέσεων"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!pagonisInfoFile"
                        :loading="pagonisInfoFile && loading"
                        @click="uploadPagonisInfoFile"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="hasBackOfficeSap" class="download-card">
                <v-card-title>
                    <v-icon color="blue" class="mr-2">mdi-timeline-check-outline</v-icon>Back Office SAP Checks
                </v-card-title>
                <v-menu
                    v-model="sapMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    class="filter-field"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="sapFilterDateText"
                            class="filter-field calendar"
                            label="Ημ/νία SAP Check"
                            readonly
                            clearable
                            @click:clear="sapFilterDateRange = []"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <template v-slot:prepend-inner>
                                <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-calendar</v-icon>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="sapFilterDateRange"
                        range
                        color="#0047AB"
                        locale="el"
                        @change="sapFilterDateSelected"
                        @input="() => { if ( sapFilterDateRange.length === 2) { sapMenu = false }}"
                    ></v-date-picker>
                </v-menu>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="sapFilterDateRange.length !== 2"
                        :loading="sapFilterDateRange.length === 2 && loading"
                        @click="exportBackOfficeSap"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="config.hasStorage" class="download-card">
                <v-card-title>
                    <v-icon color="#9F2B68">mdi-warehouse</v-icon>Υλικά στην Αποθήκη
                </v-card-title>
                <v-select
                    v-model="selectedClient"
                    :items="clients"
                    clearable
                    return-object
                    item-text="name"
                    label="Πάροχος"
                    class="field mx-4"
                ></v-select>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :loading="loading"
                        @click="exportMaterials"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="config.hasStorage" class="download-card">
                <v-card-title>
                    <v-icon color="#9F2B68">mdi-warehouse</v-icon>Χρησιμοποιημένα Υλικά
                </v-card-title>
                <v-select
                    v-model="selectedClient2"
                    :items="clients"
                    clearable
                    return-object
                    item-text="name"
                    label="Πάροχος"
                    class="field mx-4"
                ></v-select>
                <div class="export-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :loading="loading2"
                        @click="exportUsedMaterials"
                    >
                        Export
                    </v-btn>
                </div>
            </v-card>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>
<script>
    import jwtUtil from '@/utils/jwtUtil'
    import materialService from '@/services/material'
    import Alert from '@/components/Alert'
    import client from '@/services/client'
    import assignmentService from '@/services/assignment'
    import backOfficeService from '@/services/backOffice'
    import momentTimezone from 'moment-timezone'
    import fileUtil from '@/utils/file'

    export default {
        components: { Alert },
        data() {
            return {
                clients: [],
                selectedClient: null,
                selectedClient2: null,
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                sapLoading: false,
                pagonisInfoFile: null,
                loading2: false,
                sapMenu: false,
                sapFilterDateRange: [],
                sapFilterDateText: ''
            }
        },
        computed: {
            hasBackOfficeSap() {
                return this.config?.backOffice?.steps?.some(step => step.value === 'sapUpload')
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            config() {
                return this.$store.getters.getConfig || {}
            }
        },
        created() {
            client.getAllClients().then(resp => {
                this.clients = resp.data
            })
        },
        methods: {
            sapFilterDateSelected(dateRange) {
                this.sapFilterDateText = dateRange[0] + ' ~ ' + dateRange[1]
            },
            exportBackOfficeSap() {
                this.sapLoading = true
                let dateRange = []
                dateRange[0] = momentTimezone(this.sapFilterDateRange[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                dateRange[1] = momentTimezone(this.sapFilterDateRange[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                backOfficeService.exportBackOfficeSap(dateRange).then(response => {
                    fileUtil.createExport(this.sapFilterDateRange[0] + '_' + this.sapFilterDateRange[1] + '_' + 'backoffice-sap-checks', response.data)
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                }).catch((error) => {
                    if (error.response.data?.code === 'NO_DATA') {
                        this.setAlert('Δεν βρέθηκαν δεδομένα για εξαγωγή', 'error')
                    } else {
                        this.setAlert(error.response.data.message, 'error')
                    }
                }).finally(() => {
                    this.sapLoading = false
                })
            },
            uploadPagonisInfoFile() {
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.pagonisInfoFile)
                assignmentService.createPagonisInfoFile(formData).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'pagonis-assignment-info.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.pagonisInfoFile = null
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            exportMaterials() {
                this.loading = true
                materialService.exportMaterials(this.selectedClient ? this.selectedClient.id : null).then(resp => {
                    this.downloadFile(resp.data, 'Materials' + (this.selectedClient ? ` - ${this.selectedClient.name}` : ' - General'))
                    this.selectedClient = null
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            exportUsedMaterials() {
                this.loading2 = true
                materialService.exportUsedMaterials(this.selectedClient2 ? this.selectedClient2.id : null).then(resp => {
                    this.downloadFile(resp.data, 'Used Materials' + (this.selectedClient2 ? ` - ${this.selectedClient2.name}` : ' - General'))
                    this.selectedClient2 = null
                    this.setAlert('To export ολοκληρώθηκε επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading2 = false
                })
            },
            downloadFile(fileData, fileName) {
                const data = 'text;charset=utf-8,' + encodeURIComponent(fileData)
                const link = document.createElement('a')
                link.href = 'data:' + data
                link.download = `${fileName}.csv`

                const container = document.getElementById('export')
                container.appendChild(link)
                link.click()
            }

        }
    }
</script>
<style scoped>
.download-card {
    width: 350px;
    margin: 1rem;
    padding: 1rem;
    background: var(--cards-and-tables-color);
    color: var(--cards-and-tables-text-color);
    display: flex;
    flex-direction: column;
}
.export-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
.export-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.export-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>
